import React from 'react';
function LayoutMenu(_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "elmo-layout__main-menu", role: "navigation", "aria-label": "main menu" }, children));
}
export default LayoutMenu;
